"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRole = exports.ZABBIX_VERSION = exports.ProblemStatus = exports.DayOfWeek = void 0;
var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["SUNDAY"] = "sunday";
    DayOfWeek["MONDAY"] = "monday";
    DayOfWeek["TUESDAY"] = "tuesday";
    DayOfWeek["WEDNESDAY"] = "wednesday";
    DayOfWeek["THURSDAY"] = "thursday";
    DayOfWeek["FRIDAY"] = "friday";
    DayOfWeek["SATURDAY"] = "saturday";
})(DayOfWeek || (exports.DayOfWeek = DayOfWeek = {}));
var ProblemStatus;
(function (ProblemStatus) {
    ProblemStatus["ACKNOWLEDGE"] = "acknowledge";
    ProblemStatus["RESOLVED"] = "resolved";
})(ProblemStatus || (exports.ProblemStatus = ProblemStatus = {}));
var ZABBIX_VERSION;
(function (ZABBIX_VERSION) {
    ZABBIX_VERSION["V5"] = "5";
    ZABBIX_VERSION["V6"] = "6";
    ZABBIX_VERSION["V7"] = "7";
})(ZABBIX_VERSION || (exports.ZABBIX_VERSION = ZABBIX_VERSION = {}));
var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "admin";
    UserRole["OPERATOR"] = "operator";
})(UserRole || (exports.UserRole = UserRole = {}));
